<div class="col-12 barChartContainer" id="{{chartId}}"></div>